import { render } from "./busquedaavanzada.vue?vue&type=template&id=1939a88d&scoped=true"
import script from "./busquedaavanzada.vue?vue&type=script&lang=js"
export * from "./busquedaavanzada.vue?vue&type=script&lang=js"

import "./busquedaavanzada.vue?vue&type=style&index=0&id=1939a88d&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1939a88d"]])

export default __exports__